module.exports = __webpack_public_path__ + "img/icon.056bbd9e.png";